/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import Row from 'components/UIKit/Flex/Row';
import ProjectsColumns from './ProjectsColumns';
import ProjectsRows from './ProjectsRows';

type ProjectsTableProps = {
  sort: string,
  order: string,
  router: Object,
  children: any,
  filterValue: string,
  isFetching: boolean,
};

let filterProjects = filterValue => {
  return project => {
    return filterValue
      ? Object.keys(project).some(
          key =>
            typeof project[key] === 'string' &&
            project[key].toLowerCase().includes(filterValue.toLowerCase()),
        )
      : true;
  };
};

export default function ProjectsTable({
  sort,
  order,
  router,
  children,
  filterValue,
  isFetching,
  projectRoles,
}: ProjectsTableProps): React.Element {
  let filteredChildren = children.filter(filterProjects(filterValue));

  if (!filteredChildren.length) {
    return (
      <Row style={{ padding: '0.5rem' }}>
        {isFetching ? '' : 'No projects match filter.'}
      </Row>
    );
  }

  return (
    <Table>
      <ProjectsColumns sort={sort} order={order} />
      <ProjectsRows router={router} projectRoles={projectRoles}>
        {filteredChildren}
      </ProjectsRows>
    </Table>
  );
}
